import React from 'react'

const IEBlocker = () => (
  <div className="text-center mt-5">
    <h1 className="text-muted">IE support coming soonish... for now use Chrome.</h1>
    <img height={100} src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Google_Chrome_logo_and_wordmark_%28Carlitoscarlos%29.svg/1024px-Google_Chrome_logo_and_wordmark_%28Carlitoscarlos%29.svg.png" alt="Google Chrome Logo" className="img-responsive mt-5" />
    <br /><br />
    <a href="https://www.google.com/chrome/?brand=CHBD&gclid=EAIaIQobChMI_PHi58ej2QIV2DyBCh26DwO1EAAYASAAEgKcr_D_BwE" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg mt-4">Install Now</a>
  </div>
)

export default IEBlocker



// WEBPACK FOOTER //
// ./src/components/ui/environment/IEBlocker.js